import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Camera } from "lucide-react";

export function ServizioFoto({ im, onDone }) {
  const [fotografi, setFotografi] = useState([]);
  const [f, setF] = useState({ fotografo_id: im.servizio_foto?.fotografo_id || "", data: im.servizio_foto?.data || "" });
  useEffect(() => { api.get("/fotografi").then((r) => setFotografi(r.data)).catch(() => {}); }, []);
  const sv = im.servizio_foto;
  const assegna = async () => {
    try { await api.post(`/immobili/${im.id}/servizio-foto`, f); toast.success("Fotografo assegnato e avvisato"); onDone(); } catch (e) { toast.error(apiError(e)); }
  };
  const togli = async () => { if (!window.confirm("Togliere il servizio foto?")) return; try { await api.delete(`/immobili/${im.id}/servizio-foto`); onDone(); } catch (e) { toast.error(apiError(e)); } };
  return (
    <div className="card-immo p-4" data-testid="servizio-foto-box">
      <div className="flex items-center gap-2 mb-2 font-semibold text-sm"><Camera size={16} className="text-[#FC82ED]" /> Servizio foto
        {sv && <span data-testid="servizio-foto-stato" className={`px-2 py-0.5 rounded-full text-[11px] font-bold ${sv.stato === "fatto" ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>{sv.stato === "fatto" ? "Fatto" : "Assegnato"}</span>}
      </div>
      {sv && <p className="text-xs text-[var(--muted)] mb-2">{sv.fotografo_nome} · {sv.data?.split("-").reverse().join("/")}</p>}
      <div className="flex flex-wrap gap-2">
        <select data-testid="servizio-foto-fotografo" value={f.fotografo_id} onChange={(e) => setF({ ...f, fotografo_id: e.target.value })} className="px-3 py-2 rounded-xl border border-[var(--border)] text-sm">
          <option value="">— Fotografo —</option>{fotografi.map((x) => <option key={x.id} value={x.id}>{x.nome}</option>)}
        </select>
        <input type="date" data-testid="servizio-foto-data" value={f.data} onChange={(e) => setF({ ...f, data: e.target.value })} className="px-3 py-2 rounded-xl border border-[var(--border)] text-sm" />
        <button data-testid="servizio-foto-assegna" disabled={!f.fotografo_id || !f.data} onClick={assegna} className="px-4 py-2 rounded-xl bg-[#111111] text-white text-sm font-semibold disabled:opacity-40">{sv ? "Aggiorna" : "Assegna"}</button>
        {sv && <button data-testid="servizio-foto-togli" onClick={togli} className="px-3 py-2 rounded-xl border border-[var(--border)] text-sm">Togli</button>}
      </div>
    </div>
  );
}
